/**
 * Trustpilot Plugin for Static Sites
 * This plugin ensures Trustpilot widgets are properly initialized
 * across all pages in a static site deployment.
 */

import Vue from "vue"

export default () => {
  // Only run on client-side
  if (typeof window === "undefined") return

  // Add a global mixin that handles Trustpilot initialization
  Vue.mixin({
    mounted() {
      // Initialize Trustpilot when component is mounted
      this.$nextTick(() => {
        // Add a small delay to ensure DOM is fully rendered
        setTimeout(() => {
          initializeTrustpilot()
        }, 200)
      })
    },
    updated() {
      // Reinitialize Trustpilot when component is updated
      this.$nextTick(() => {
        // Add a small delay to ensure DOM is fully rendered
        setTimeout(() => {
          initializeTrustpilot()
        }, 200)
      })
    },
  })

  // Function to initialize Trustpilot
  const initializeTrustpilot = () => {
    // Check if there are any Trustpilot widgets on the page
    const trustpilotWidgets = document.querySelectorAll(".trustpilot-widget")
    const hasTrustpilotWidgets = trustpilotWidgets.length > 0

    if (!hasTrustpilotWidgets) return

    // Check if Trustpilot script is already loaded
    if (window.Trustpilot) {
      // Script exists, just reinitialize widgets
      setTimeout(() => {
        // Initialize each widget individually
        trustpilotWidgets.forEach((widget) => {
          try {
            window.Trustpilot.loadFromElement(widget)
          } catch (e) {
            console.warn("Error initializing Trustpilot widget:", e)
          }
        })
      }, 100)
      return
    }

    // First load - add the script if it doesn't exist
    if (!document.getElementById("trustpilot-script")) {
      const script = document.createElement("script")
      script.id = "trustpilot-script"
      script.type = "text/javascript"
      script.src =
        "https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js"
      script.async = true
      script.defer = true

      script.onload = () => {
        if (window.Trustpilot) {
          // Initialize after script loads
          const widgets = document.querySelectorAll(".trustpilot-widget")
          widgets.forEach((widget) => {
            try {
              window.Trustpilot.loadFromElement(widget)
            } catch (e) {
              console.warn("Error initializing Trustpilot widget:", e)
            }
          })
        }
      }

      document.body.appendChild(script)
    }
  }

  // Initialize on first page load
  if (document.readyState === "complete") {
    setTimeout(initializeTrustpilot, 300)
  } else {
    window.addEventListener("load", () => {
      setTimeout(initializeTrustpilot, 300)
    })
  }

  // Special handling for index page
  if (
    window.location.pathname === "/" ||
    window.location.pathname === "/index.html"
  ) {
    const indexPageCheck = setInterval(() => {
      if (document.querySelectorAll(".trustpilot-widget").length > 0) {
        initializeTrustpilot()
        clearInterval(indexPageCheck)
      }
    }, 500)

    // Clear the interval after 10 seconds to prevent infinite checking
    setTimeout(() => clearInterval(indexPageCheck), 10000)
  }
}
